<template>
  <div class="table-responsive">
    <table class="table table-striped table-vcenter table-bordered">
      <thead>
        <tr>
          <th width="5%" class="text-center">趟数</th>
          <th class="text-center">型号</th>
          <th class="text-center">序列号</th>
          <th class="text-center">尺寸(mm)</th>
          <th class="text-center">入井时间</th>
          <th class="text-center">起出时间</th>
          <th class="text-center">进尺(m)</th>
          <th class="text-center">纯钻时间(h)</th>
          <th class="text-center">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(trip, index) in list" :key="trip.id">
          <td class="text-center">{{ index + 1 }}</td>
          <td class="text-center">
            {{ trip.model_number || '无' }}
          </td>
          <td class="text-center">
            <DrillLink :no="trip.serial_number"></DrillLink>
          </td>
          <td class="text-center">{{ trip.size }}</td>
          <td class="text-center">{{ trip.enter_time }}</td>
          <td class="text-center">{{ trip.out_time }}</td>
          <td class="text-center">{{ trip.drill_footage }}</td>
          <td class="text-center">{{ trip.drill_time }}</td>
          <td class="text-center">
            <el-button
              v-code="23102"
              type="text"
              size="mini"
              @click="$router.push(`/report/drill_trips/${trip.id}`)"
              >详情</el-button
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
}
</script>